module.exports = __webpack_public_path__ + "static/media/28-min.jpg.481eb34e.webp";